export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: '91-video',
    name: '91视频',
    description: '91视频专区，汇集海量高清数字视频资源，涵盖热门影视、综艺娱乐、纪录片等多种类型，为您带来极致的在线观看体验。',
    icon: 'ri-movie-line',
  },
  {
    slug: '97-video',
    name: '97视频',
    description: '97视频频道，专注于精选优质数字视频内容，每日更新最新最热视频资源，满足您多样化的观影需求。',
    icon: 'ri-vidicon-line',
  },
  {
    slug: '51-video',
    name: '51视频',
    description: '51视频分类，打造全面的数字视频大全，集合各类精彩视频内容，让您一站式畅享高清视觉盛宴。',
    icon: 'ri-live-line',
  },
  {
    slug: 'jiujiu-video',
    name: '久久视频',
    description: '久久视频专区，致力于提供持久的优质视频观看体验，海量资源持续更新，经典与新作并存。',
    icon: 'ri-play-circle-line',
  },
  {
    slug: 'digital-video',
    name: '数字视频大全',
    description: '数字视频大全频道，整合全网数字视频资源，打造最全面的视频聚合平台，一站在手，精彩全有。',
    icon: 'ri-tv-line',
  },
];